/* RESPONSIBLE TEAM: team-knowledge-foundations */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    ticketsPortalRuleset: { embedded: 'always' },
    ticketsPortalVisibilityRuleset: { embedded: 'always' },
    consentBanner: { embedded: 'always' },
  },
});
